import { Injectable } from '@angular/core';
import {
  IPideloAdminData,
  IPideloCategoriaActualizada,
  IPideloConfig,
  IPideloProductoActualizado,
} from '@core/interfaces/entidades/pidelo.entidad';
import {
  IActualizarPideloCategoriaReq,
  IActualizarPideloConfigReq,
  IActualizarPideloProductoReq,
} from '@core/interfaces/request-response/pidelo.dto.interface';
import { environment } from '@env/environment';
import { BaseHttpService } from '@shared/services/base-http.service';

@Injectable({
  providedIn: 'root',
})
export class PideloApiService extends BaseHttpService {
  private readonly baseUrl = `${environment.apiUrl}${environment.apiPreFix}/pidelo`;

  cargarAdmin() {
    return this.withLoader(this.httpClient.get<IPideloAdminData>(`${this.baseUrl}/admin`));
  }

  guardarConfig(req: IActualizarPideloConfigReq) {
    return this.withLoader(this.httpClient.put<IPideloConfig>(`${this.baseUrl}/admin/config`, req));
  }

  actualizarProducto(id: number, req: IActualizarPideloProductoReq) {
    return this.httpClient.patch<IPideloProductoActualizado>(`${this.baseUrl}/admin/productos/${id}`, req);
  }

  actualizarCategoria(id: number, req: IActualizarPideloCategoriaReq) {
    return this.httpClient.patch<IPideloCategoriaActualizada>(`${this.baseUrl}/admin/categorias/${id}`, req);
  }
}
